<rk-page-title [title]="'SIDENAV.MENU.PROGRAMS' | translate"></rk-page-title>
<div class="text-gray-darkest -mt-3 hidden md:block" translate>
  SCHEDULE.PROGRAMS.HINT
</div>
<div class="flex flex-col-reverse md:flex-col -mt-2 md:mt-2">
  <div class="program-add-search flex-1 mb-5 md:mb-0">
    <rk-button
      class="hidden md:inline-block"
      [label]="'SCHEDULE.PROGRAMS.NEW_PROGRAM' | translate"
      [faIcon]="'fa-plus'"
      (click)="createProgram()"
    ></rk-button>
    <rk-search-bar
      *ngIf="(programs$ | async)?.length"
      type="program"
      class="w-full md:w-auto"
      (inputted)="editSearch($event)"
      [value]="memorizedSearch"
    ></rk-search-bar>
  </div>
  <div class="infos mt-0 mb-4 md:my-3 text-gray-darkest">
    <ng-container *ngIf="(programs$ | async)?.length">
      {{
        'SCHEDULE.PROGRAMS.PROGRAMS_NUMBER'
          | translate: { count: (programs$ | async)?.length }
      }}
      -
      {{
        'SCHEDULE.PROGRAMS.ESTIMATED_DURATION'
          | translate: getMinutesAndHours(estimatedDuration$ | async)
      }}
    </ng-container>
  </div>
</div>
